import { useParams } from "react-router-dom"
import AppRedirectScreen from "../components/AppRedirectScreen"

function PostView() {
  const { postId } = useParams()

  return <AppRedirectScreen type="moment" deepLink={`pepchat://post/${postId}`} />
}

export default PostView
